export default "/images/vendor/flag-icons/flags/4x3/wf.svg?2a313731eae3ed3e6bf36d28026f85ca";